import { graphql } from "gql";

const FILE_FRAGMENT = graphql(`
  fragment File on File {
    id
    messageId
    messageThreadId
    name
    createTime
    userId
    contentType
    byteCount
    previewContentType
    cloudFrontUrl
    previewCloudFrontUrl
    key
    previewKey
    isCompressed
    isVoiceNote
    voiceNoteText
    voiceNoteStatus
    voiceNoteLocale
    voiceNoteLocalizedText
  }
`);

export default FILE_FRAGMENT;
